import cn from "classnames";

import { ImgBgResponsive } from "@/src/component/base/ImgBgResponsive";
import { StrapiComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import { ButtonLinkModule, TextModule } from "@/src/component/partial/__module__";

import styles from "./CardScroll.module.scss";

interface CardScrollSlideProps {
  index: number;
  card: StrapiComponentType.Element.CarouselCard;
  quality: number;
  lazy?: "eager" | "lazy";
  mobileHint?: boolean;
  total: number;
  deviceWidthHint?: number;
}

function CardScrollSlide({ index, card, quality, lazy, mobileHint, total, deviceWidthHint }: CardScrollSlideProps) {
  const eagerMobile = (index ?? 0) < 2 || index + 1 === total ? "eager" : "lazy";
  const eagerDesktop = (index ?? 0) < 3 ? "eager" : "lazy";
  const _lazy = lazy === "lazy" ? "lazy" : mobileHint ? eagerMobile : eagerDesktop;

  return (
    <>
      <ImgBgResponsive
        className={styles.background}
        imageUrl={LoadFromCDN.imageQualityAndSizeOptional(
          card?.backgroundImage.data?.attributes.url,
          quality,
          mobileHint ? deviceWidthHint : undefined
        )}
        lazy={_lazy}
        prefetch={_lazy === "eager"}
        triggers={["swiperSlideChange", "click", "touchstart", "scroll"]}
      >
        {card?.overlayImage?.data?.attributes?.url && (
          <ImgBgResponsive
            className={cn(styles.overlayImage, styles.bottom)}
            imageUrl={LoadFromCDN.imageQualityAndSizeOptional(
              card?.overlayImage.data?.attributes.url,
              quality,
              mobileHint ? deviceWidthHint : undefined
            )}
            lazy={_lazy}
            prefetch={_lazy === "eager"}
            triggers={["swiperSlideChange", "click", "touchstart", "scroll"]}
          />
        )}
      </ImgBgResponsive>
      <div className={styles.textContainer}>
        <TextModule
          text={{
            tag: "body1",
            text: card.title,
          }}
          className={styles.cardTitle}
        />
        <TextModule
          text={{
            tag: "body1",
            text: card.subtitle,
          }}
          className={styles.cardSubtitle}
        />
        {card.cta ? (
          <ButtonLinkModule
            className={styles.ctaLink}
            buttonLink={card.cta}
            forceButton={true}
          />
        ) : (
          <TextModule
            text={{
              tag: "body1",
              text: card.underSubtitle,
            }}
            className={styles.underSubtitle}
          />
        )}
      </div>
    </>
  );
}

export default CardScrollSlide;
